import { usePage } from '@inertiajs/react'
import type { SharedProps } from '@/frontend/types/inertia'
import type { ReactNode } from 'react'
import type { FdeCopy } from '@/frontend/features/Fde/types'

interface Props {
  copy: FdeCopy
  eyebrow: string
  title: string
  description: string
  actions?: ReactNode
  projectId?: string | null
  variant?: 'default' | 'workspace'
  children: ReactNode
}

export default function FdeShell({ title, actions, children }: Props) {
  const { props } = usePage<SharedProps>()
  const contextual = props.featureFlags?.worker_first_nav_enabled && props.permissions?.can_access_forge
  return (
    <main data-testid="fde-workspace" className="flex h-full min-h-0 flex-col overflow-hidden bg-background">
      {!contextual && <header data-testid="fde-workspace-header" className="flex h-12 shrink-0 items-center gap-3 border-b border-border bg-background px-4 md:px-5">
        <h1 className="min-w-0 flex-1 truncate text-base font-semibold text-foreground">{title}</h1>
        {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
      </header>}
      <div className="min-h-0 flex-1 overflow-hidden">{children}</div>
    </main>
  )
}
